import { render, staticRenderFns } from "./navigate.vue?vue&type=template&id=b7b9d380&scoped=true&"
import script from "./navigate.vue?vue&type=script&lang=js&"
export * from "./navigate.vue?vue&type=script&lang=js&"
import style0 from "./navigate.vue?vue&type=style&index=0&id=b7b9d380&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7b9d380",
  null
  
)

export default component.exports